import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'antd-v5';
import { ChevronDownIcon } from 'assets/icons';
import { getOrderClaimForm, setOrderClaimForm } from 'domains/order/Order.store';
import { ClaimFormType, DIRECT_DELIVERY, FULL_OTC } from 'domains/order/Order.types';
import { getTokenUser } from 'domains/user';
import { theme } from 'styles';
import { BlackButton, Flex, Icon, Pipeline, Text } from 'UI';
import { Country } from 'utils/i18n/Country';

const InitiateClaimButton = ({ setIsOpen }: { setIsOpen: (b: boolean) => void }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const tokenUser = useSelector(getTokenUser);
  const userCountry = Country.findByKey(tokenUser?.country);
  const isFRUser = userCountry?.key === Country.FR.key;
  const claimForm = useSelector(getOrderClaimForm);
  const [selectOptionOpen, setSelectOptionOpen] = useState(false);

  const openForm = (formType: ClaimFormType) => {
    dispatch(setOrderClaimForm({ ...claimForm, formType }));
    setIsOpen(true);
  };

  const items = [
    {
      label: <Text type="base">{'Select Claim Type'}</Text>,
      key: 0,
      disabled: true,
    },
    {
      label: t('order.claim.form_type.full_otc', 'Full OTC'),
      key: '1',
      onClick: () => openForm(FULL_OTC),
    },
    {
      label: t('order.claim.form_type.direct_delivery', 'Direct Delivery'),
      key: '2',
      onClick: () => openForm(DIRECT_DELIVERY),
    },
  ];

  const handleSelectDefault = (b: boolean) => {
    if (isFRUser) {
      setSelectOptionOpen(b);
    } else {
      openForm(FULL_OTC);
    }
  };

  return (
    <Dropdown menu={{ items }} open={selectOptionOpen} onOpenChange={handleSelectDefault} trigger={['click']}>
      <BlackButton>
        <Flex gap={15} align={'center'}>
          {t('order.claim.action.create_new_claim', 'Create new claim')}
          <Pipeline size={40} color={theme.color.white} />
          <Icon IconComponent={ChevronDownIcon} size={16} />
        </Flex>
      </BlackButton>
    </Dropdown>
  );
};

export default InitiateClaimButton;
